var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm.refreshKey,
      class: _vm.assignAppBackground(),
      attrs: { id: "app" }
    },
    [
      _c("BaseOffline"),
      _vm._v(" "),
      _vm.hasNavigation
        ? _c("header-adapter", {
            attrs: {
              "adapter-name": "AppHeader",
              path: "header",
              id: "app-header"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "mainContainer",
          class: _vm.styleForContainer(),
          attrs: { id: "main-container" }
        },
        [
          _vm.showTrackerInApp() ? _c("order-tracker-container") : _vm._e(),
          _vm._v(" "),
          _c("transition-route")
        ],
        1
      ),
      _vm._v(" "),
      _c("mobile-checkout-footer"),
      _vm._v(" "),
      _vm.showItemDetailActionFooter()
        ? _c("item-detail-actions-mobile")
        : _vm._e(),
      _vm._v(" "),
      _vm.routeHasFooter() ? _c("app-footer", { ref: "appFooter" }) : _vm._e(),
      _vm._v(" "),
      _c("modals-container")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 